<template>
    <div class="container">
        <div class="columns">
            <div class="column is-6">
                <h1 class="title is-1">Contact Us</h1>
                <br/>
                <h2 class="subtitle is-3">Gulf Coast Contractors, Inc.</h2>
                <p>
                    1-877-MOV-TREE <a href="tel:18776688733"><small>(1-877-668-8733)</small></a>
                    <br/>
                    <a href="tel:19564126384">(956) 412-6384</a>
                    <br/>
                    <a href="mailto:info@gulfcoastrgv.com">info@gulfcoastrgv.com</a>
                </p>
                <p>
                    25691 Altas Palmas Rd
                    <br/>
                    Harlingen, TX 78552
                </p>
                <p>
                    <strong>Office Hours:</strong>
                    <br/>
                    8AM - 5PM CDT
                    <br/> Monday-Friday
                </p>
            </div>
            <div class="column is-6">
                <transition name="fadeInGrow" mode="out-in" appear>
                    <div v-if="sent" class="message-sent">
                        <h1 class="subtitle is-3">
                            Message sent successfully!
                        </h1>
                    </div>
                </transition>
                <div v-if="!sent">
                    <h2 class="subtitle is-4">
                        Request more information
                        <br/>
                        <em><small>Typically answered in 1 to 2 hours, or by the next business day.</small></em>
                    </h2>
                    <text-input label="Your name"
                                name="name"
                                v-model="form.name"
                                :errors="form.errors.get('name')"
                                @event="form.listen($event)"
                    ></text-input>
                    <text-input label="Your email"
                                name="email"
                                type="email"
                                placeholder="you@example.com"
                                v-model="form.email"
                                :errors="form.errors.get('email')"
                                @event="form.listen($event)"
                    ></text-input>
                    <text-input label="Subject"
                                name="subject"
                                placeholder="e.g. Tree relocation"
                                v-model="form.subject"
                                :errors="form.errors.get('subject')"
                                @event="form.listen($event)"
                    ></text-input>
                    <text-input label="Message"
                                name="message"
                                type="textarea"
                                placeholder="Explain what you need and provide any relevant information - include your phone number if you would like a call back."
                                v-model="form.message"
                                :errors="form.errors.get('message')"
                                @event="form.listen($event)"
                    ></text-input>

                    <div class="field is-grouped">
                        <p class="control">
                            <button :class="{'button is-primary': true, 'is-loading': sending}"
                                    @click="submitForm()">
                                Submit
                            </button>
                        </p>
                        <p class="control">
                            <button class="button is-link" :disabled="sending" @click="form.reset()">Cancel</button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .message-sent {
        padding: 150px 0 250px;
        text-align: center;
        .subtitle {
            color: #4cae4c !important;
        }
    }

    @keyframes fadeInGrow {
        0% {
            opacity: 0;
            transform: scale(0.5)
        }
        100% {
            opacity: 1;
            transform: scale(1)
        }
    }

    @keyframes fadeOutShrink {
        0% {
            opacity: 1;
            transform: scale(1)
        }
        100% {
            opacity: 0;
            transform: scale(0.5)
        }
    }

    .fadeInGrow-enter-active {
        animation: fadeInGrow 1s;
    }

    .fadeInGrow-enter {
        opacity: 0;
    }

    .fadeInGrow-leave {
        opacity: 1;
    }

    .fadeInGrow-leave-active {
        animation: fadeOutShrink 1s;
    }
</style>

<script>
    import axios from "axios"
    import {Form} from "vuex-forms"
    import {
        required,
        email,
        minLength,
        maxLength
    } from "vuex-forms/lib/validators"
    export default {
        name: 'contact',
        data () {
            return {
                form: new Form(this, {
                    name: null,
                    email: null,
                    subject: null,
                    message: null,
                }, {
                    validations: {
                        name: {required},
                        email: {required, email},
                        subject: {required, maxLength: maxLength(100)},
                        message: {required, maxLength: maxLength(800)},
                    },
                    inputDebounce: 500,
                }),
                sent: false,
                sending: false,
            }
        },
        methods: {
            submitForm() {
                this.form.$v.$touch()
                let errors = this.form.validate()
                if (Object.keys(errors).length > 0) return false;
                this.sending = true

                setTimeout(() => {
                    let data = this.form.data()
                    return axios({
                        method: 'post',
                        url: '/api/send',
                        data
                    }).then(data => {
                        this.form.reset()
                        this.form.name    = null
                        this.form.email   = null
                        this.form.subject = null
                        this.form.message = null
                        this.sent         = true;
                        this.sending      = false
                    }).catch(error => {
                        let errors = error.response.data
                        this.form.errors.clear()
                        this.form.errors.record(errors)
                        this.sending = false
                    })
                }, 500)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Contact.vue?516e7db6